import React from "react"
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import FieldString_RenderEditableInlineInput from './inline-editable/input-editable-inline'

export default function FieldString_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <FieldString_RenderEditableInlineInput {...props} value={value} onChange={props.onChange}/>

}